var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inputs" }, [
    _c("div", { staticClass: "input input-container" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("settings.emailTitle")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.clone.mail,
            expression: "clone.mail",
          },
        ],
        attrs: { placeholder: _vm.$t("login.email"), "no-flags": "" },
        domProps: { value: _vm.clone.mail },
        on: {
          update: _vm.handleEmailUpdate,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.clone, "mail", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input input-container" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("settings.emailMessage")))]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "input", placeholder: "Type message here.." },
        domProps: { value: _vm.clone.text },
        on: { input: _vm.handleOnTextChange },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }